import { api_url } from "./constant";
import { getLocalStorage } from "./util-service";
import axios from "axios";
// export const getDataByTitleAndCategory = (keyword) => {
//   let categorySelected = category || defaultCategory;
//   return fetch(`${api_url}?title=${keyword}&Category=${categorySelected}`, {
//     cache: "force-cache",
//   });
// };
let authToken;
let username;

function getAuthDetails() {
  authToken = getLocalStorage("authToken");
  username = getLocalStorage("username");

  // console.log("service authToken", authToken);
}

// UN-AUTHENTICATION interceptors
axios.interceptors.response.use(
  (response) => {
    // If the request succeeds, return the response

    return response;
  },
  (error) => {
    // If the request fails
    if (error.response.status === 401 || error.response.status === 403) {
      // Handle 401 status code here, for example, redirect to login page
      console.log("Unauthorized. Redirecting to login page...");
      // Example: navigate to login page
      window.location.href = "/login";
    }
    // Return any error so it can be caught by the calling function
    return Promise.reject(error);
  }
);

export const postLogin = async (obj) => {
  try {
    const response = await axios.post(`${api_url}/api/auth/signin`, obj);
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getUserTokenVerify = async (token) => {
  try {
    const response = await axios.get(`${api_url}/api/auth/verify-user`, {
      headers: {
        "x-access-token": token,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

// export const postCreateVendor = async (obj) => {
//   const authToken = getLocalStorage("authToken");
//   try {
//     const response = await axios.post(`${api_url}/admin/add-vendor`, obj, {
//       headers: {
//         "x-access-token": authToken,
//       },
//     });
//     return response;
//   } catch (error) {
//     console.error("Error sending data:", error);
//     return error;
//   }
// };

export const postAddressForm = async (formData, editMode) => {
  getAuthDetails();
  try {
    let response;
    if (editMode) {
      response = await axios.put(
        `${api_url}/samagri/${formData.id}?authToken=${authToken}&username=${username}`,
        formData
      );
    } else {
      response = await axios.post(
        `${api_url}/samagri?authToken=${authToken}&username=${username}`,
        formData
      );
    }
    // console.log("Data sent:", response.data);
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getSearchByQuery = async (mNo, status) => {
  getAuthDetails();
  let url = `${api_url}/samagri?authToken=${authToken}&username=${username}`;
  if (mNo) {
    url += `&phone=${mNo}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  try {
    const response = await axios.get(url);
    // console.log("Mumber search:", response.data);
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      localStorage.setItem("check", true);
    }
  }
};

export const postRegistration = async (formData) => {
  getAuthDetails();
  try {
    let response;
    response = await axios.post(
      `${api_url}/registration?authToken=${authToken}&username=${username}`,
      formData
    );

    // console.log("Data sent:", response.data);
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const searchMobileIfRegistered = async (mobilenumber) => {
  getAuthDetails();
  try {
    let response;
    response = await axios.get(
      `${api_url}/registration?authToken=${authToken}&username=${username}&phone=${mobilenumber}`
    );

    // console.log("Data sent:", response.data);
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};
